/**
 * Words for how an expense came to be linked to a job, and why an upload is
 * asking. The decisions themselves are fn_match_expense_job's (20261019130000).
 */

/** ledger_headers.job_link_method, in words. */
export function jobLinkMethodLabel(method: string | null | undefined): string | null {
    switch (method) {
        case 'picked': return 'Linked when uploaded';
        case 'job_reference': return 'Linked automatically: job number on the invoice';
        case 'registration': return 'Linked automatically: registration on the invoice';
        case 'parts': return 'Linked automatically: invoice lines match the job’s parts';
        case 'manual': return 'Linked by hand';
        default: return null;
    }
}

/** ledger_headers.job_link_review.reason, in words. */
export const JOB_LINK_REVIEW_REASON: Record<string, string> = {
    several_jobs_match: 'More than one open job has these parts on it.',
    partial_match: 'Some lines match this job’s parts, but not enough to be sure.',
    several_open_jobs_for_registration: 'The registration on the invoice has more than one open job.',
    registration_has_no_open_job: 'The registration on the invoice has no open job — maybe one you have finished.',
    registration_has_no_job: 'The registration on the invoice belongs to a car with no job on it yet.',
};
